import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';

import { RenderProductColorsComponent } from './render-product-colors.component';


@NgModule({
  declarations: [
    RenderProductColorsComponent,
  ],
  imports: [
    CommonModule,
    LazyLoadModule,
    RenderSharedModule
  ],
  exports: [
    RenderProductColorsComponent,
  ]
})
export class RenderProductColorsModule { }
